import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { resolvedRouterUseTransitions } from './utils/routerUtils';
import ScrollToTop from './layouts/dashboard/ScrollToTop';
import AllRoutes from './layouts/AllRoutes';
import LoadingWrapper from './components/LoadingWrapper';
import { BrandLoader } from './components/BrandLoader/BrandLoader';
import AppWrapper from './AppWrapper';
import AppHelmetDefaults from './components/AppHelmetDefaults';
import AppToastStack from './components/AppToastStack';
import NotificationSetup from './components/NotificationSetup';
import OrchestratorHydrator from './components/OrchestratorHydrator';

const App = () => {
	return (
		<AppWrapper>
			<HelmetProvider>
				<Router
					unstable_useTransitions={resolvedRouterUseTransitions}
				// future={{
				// 	v7_startTransition: true,
				// 	v7_relativeSplatPath: true,
				// 	v7_partialHydration: true,
				// }}
				>
					<AppHelmetDefaults />
					<ScrollToTop />
					<NotificationSetup />
					<OrchestratorHydrator />
					<Suspense fallback={<LoadingWrapper isLoading={true} fullPage dark />}>
						<AllRoutes />
					</Suspense>
					<AppToastStack />
				</Router>
			</HelmetProvider>
		</AppWrapper>
	);
};

export default App;